import { MODE_CALCUL_MANUEL } from '@/configuration/tiers/tiersConf';

export default function genererModeCalculHonoraire() {
  return {
    modeCalcul: MODE_CALCUL_MANUEL,
    applicableSurLocation: false,
    applicableSurTlpe: false,
    commentaire: null,
    montantForfaitHt: null,
    pourcentage: null,
  };
}
